import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "grid grid-cols-3 gap-3" }
const _hoisted_2 = {
  key: 0,
  class: "w-2.5 h-2.5 bg-white dark:border-gray-800 rounded-full"
}
const _hoisted_3 = { class: "text-gray-800 group-hover:text-teal-600" }
const _hoisted_4 = ["value", "checked", "onChange"]



  
export default /*@__PURE__*/_defineComponent({
  __name: 'radioBtnGroup',
  props: {
    modelValue: {
      type: String,
      required: true,
    },
    options: {
      type: Array as () => Array<{ key: string; label: string }>,
      required: true,
    },
  },
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

  

  const emit = __emit;

  const handleChange = (value: string) => {
    emit('update:modelValue', value);
  };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option) => {
      return (_openBlock(), _createElementBlock("label", {
        key: option.key,
        class: "flex items-center gap-3 cursor-pointer group"
      }, [
        _createElementVNode("span", {
          class: _normalizeClass(["w-5 h-5 flex justify-center items-center border-2 rounded-full group-hover:border-teal-600 group-focus:ring-2 group-focus:ring-teal-600 transition", {
          'border-gray-400': __props.modelValue !== option.key,
          'border-teal-600 bg-teal-600': __props.modelValue === option.key,
        }])
        }, [
          (__props.modelValue === option.key)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2))
            : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("span", _hoisted_3, _toDisplayString(option.label), 1),
        _createElementVNode("input", {
          type: "radio",
          value: option.key,
          checked: __props.modelValue === option.key,
          onChange: ($event: any) => (handleChange(option.key)),
          class: "hidden"
        }, null, 40, _hoisted_4)
      ]))
    }), 128))
  ]))
}
}

})